import { Locale } from '../i18n/i18n-config';

export function getLocaleFromPathname(pathname: string): Locale {
  const segments = pathname.split('/');
  return segments[1] as Locale;
}
